const complexTextPrefix = 'JSON3=';
const complexTextOriginalValue = 'original';
const complexTextNormalValue = 'normal';
const complexTextDefaultFontSize = 15;
const complexTextDefaultFontFamily = 'arial';
const complexTextDynamicSourceIndicator = '␞';
const complexTextDefaultLead = 1;
const complexTextDefaultMinFontSize = 5;

const complexTextVersion = 1;

export {
  complexTextPrefix,
  complexTextOriginalValue,
  complexTextNormalValue,
  complexTextDefaultFontSize,
  complexTextDefaultFontFamily,
  complexTextDynamicSourceIndicator,
  complexTextDefaultLead,
  complexTextDefaultMinFontSize,
  complexTextVersion,
};
